<template>
    <div :class="$style.sticky_banner">
        <img
            :src="props.game.icon"
            :alt="props.game.title"
            :class="$style.icon"
        />
        <div :class="$style.texts">
            <Typography
                type="label"
                size="m"
                accent
                :class="$style.title"
            >
                {{ props.game.title }}
            </Typography>
            <Typography
                type="label"
                size="xs"
                :class="$style.category"
            >
                {{ props.categories?.categoriesInfo?.[0]?.title || '-' }}
            </Typography>
        </div>
    </div>
</template>

<script setup lang="ts">
import Typography from '@/components_new/Typography.vue'
import { APIGameType, GameCategoriesInfoType } from '@/types'

interface GameStickyBannerProps {
    game: APIGameType
    categories?: GameCategoriesInfoType
}

const props = defineProps<GameStickyBannerProps>()
</script>

<style module>
.sticky_banner {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    gap: 8px;
    background-color: var(--black);
    height: 100%;
    align-items: center;
    padding: 0 12px;
    min-width: 0;
}

.icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background-color: #bebebe;
}

.texts {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    min-width: 0;
}

.title {
    color: var(--white);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.category {
    color: var(--carbon-500);
}

@media (--tablet-plus) {
    .logo {
        width: 168px;
        height: 23px;
    }

    .icon {
        width: 48px;
        height: 48px;
    }
}
</style>
